import React, { Fragment, useEffect, useMemo } from "react";

import Loader from "../Shared/Loader";
import EditableField from "components/Shared/EditableField";
import DraggableColumnTable from "components/Shared/CustomTable/DraggableTableColumns/DraggableColumnTable";
import { selectIntensitiesByTeam } from "store/hooks/intensities";
import { useSelector } from "react-redux";
import { IntensityUI } from "store/types";
import { MESSAGES } from "config/constants";

type Props = {
  editable: boolean;
  teamId: string;
  intensitiesCopy: IntensityUI[];
  setIntensitiesCopy: React.Dispatch<React.SetStateAction<any>>;
};

const Intensities = ({
  editable,
  teamId,
  intensitiesCopy,
  setIntensitiesCopy,
}: Props) => {
  const intensities = useSelector(selectIntensitiesByTeam(teamId));

  useEffect(() => {
    if (!intensities) return;
    setIntensitiesCopy(intensities);
  }, [teamId, intensities]);

  const onChangeRows = (indexA: number, indexB: number) => {
    const newIntensityPos = [...intensitiesCopy];
    const movedIntensity = newIntensityPos[indexA];

    newIntensityPos.splice(indexA, 1);
    newIntensityPos.splice(indexB, 0, movedIntensity);
    const updated = newIntensityPos.map((item, index) => ({
      ...item,
      pos: String(index + 1),
    }));

    setIntensitiesCopy(updated);
  };
  const handleAddIntensity = () => {
    const newItem: IntensityUI = {
      id: crypto.randomUUID(),
      pos: 0,
      name: "",
      isEditable: true,
    };

    setIntensitiesCopy((prev: IntensityUI[]) => [newItem, ...prev]);
  };

  const handleRemoveIntensity = (index: number) => {
    setIntensitiesCopy((prev: any[]) => prev.filter((_, i) => i !== index));
  };

  const handleIntensityName = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = event.target.value.replace(/\s/g, "");

    setIntensitiesCopy((prev: any) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], name: value };
      return copy;
    });
  };

  const headers = [
    { content: "Intensities" },
    { content: "" },
    { content: " " },
  ];

  const rows = useMemo(() => {
    return intensitiesCopy.map((data: IntensityUI, index: any) => ({
      columns: [
        {
          content: index + 1,

          style: {
            padding: "19px 20px 19px 0px",
            textAlign: "left",
            width: "60px",
          },
          isDragHandle: editable,
          print: (content: any) => (
            <Fragment>
              {editable && (
                <img
                  src="/assets/dots.svg"
                  alt=""
                  height="15px"
                  style={{ marginTop: "-2px", marginRight: "3px" }}
                />
              )}
              <span
                style={
                  editable
                    ? { float: "right" }
                    : { marginRight: "5px", fontWeight: "bold" }
                }
              >
                {editable ? content : content + " - "}
              </span>
            </Fragment>
          ),
        },
        {
          content: data.name,
          style: { textAlign: "left" },
          class: "tt-qq",
          isDragHandle: true,
          print: (content: any) => (
            <>
              <EditableField
                itemId={index as number}
                editable={editable && data.isEditable}
                text={content}
                handleChange={handleIntensityName}
                isCustomValue={true}
              />
            </>
          ),
        },
        {
          style: {
            color: "#4F9300",
            fontWeight: "bold",
            fontSize: "13px",
            padding: "19px 0px 19px 20px",
          },
          print: () => (
            <>
              {editable && data.isEditable ? (
                <button
                  className="trash-00"
                  onClick={() => handleRemoveIntensity(index)}
                >
                  <img src="/assets/trash.svg" alt="" height="20px" />
                </button>
              ) : (
                ""
              )}
            </>
          ),
        },
      ],
      draggable: editable,
      id: data.id,
    }));
  }, [intensitiesCopy, editable]);

  return (
    <>
      <div style={{ height: "100%" }} className="periods-table-box">
        <Loader forceMessage={intensities.length === 0 ? MESSAGES.EMPTY : ""}>
          <div
            style={
              editable
                ? { height: "calc(100% - 48px)", overflowX: "auto" }
                : { height: "calc(100% - 10px)", overflowX: "auto" }
            }
          >
            {/* @ts-ignore */}

            <DraggableColumnTable
              rows={rows}
              headers={headers}
              onChangeRows={onChangeRows}
            />
          </div>
        </Loader>
        <div
          onClick={handleAddIntensity}
          style={{
            background: "#F5F5F5",
            zIndex: 7,
            display: editable ? undefined : "none",
            height: "48px",
            width: "100%",
            fontSize: "25px",
            textAlign: "center",
            fontWeight: 500,
            color: "#007ABA",
            cursor: "pointer",
            // boxShadow: '0px 0px 3px rgba(0,0,0,0.3)',
            fontFamily: "Roboto",
            position: "relative",
            bottom: "0",
          }}
        >
          <label
            className="ll-m-01"
            style={{
              fontSize: "36px",
              lineHeight: "20px",
              cursor: "pointer",
              position: "absolute",
              top: "12px",
              left: "calc(45%)",
            }}
          >
            +
          </label>
          <label
            className="ll-m-02"
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              cursor: "pointer",
              position: "absolute",
              top: "14px",
              left: "calc(45% + 26px)",
            }}
          >
            Add Intensity
          </label>
        </div>
      </div>
    </>
  );
};
export default Intensities;
